<template>
  <div>
    <md-list>
      <li class="md-list-item">
        <a
          href="javascript:void(0)"
          class="
            md-list-item-router md-list-item-container md-button-clean
            dropdown
          "
        >
          <div class="md-list-item-content">
            <drop-down direction="down">
              <md-button
                slot="title"
                class="
                  md-button md-button-link md-white md-simple
                  dropdown-toggle
                "
                data-toggle="dropdown"
              >
                <!-- {{ $store.state.lang }} -->
                <img :src="flag"
              /></md-button>
              <ul class="dropdown-menu">
                <li v-if="$store.state.lang !== 'AZ'">
                  <router-link to @click.native="onLang('AZ')"
                    ><img :src="azflag"
                  /></router-link>
                </li>
                <li v-if="$store.state.lang !== 'EN'">
                  <router-link to @click.native="onLang('EN')"
                    ><img :src="enflag"
                  /></router-link>
                </li>
              </ul>
            </drop-down>
          </div>
        </a>
      </li>
    </md-list>
  </div>
</template>

<script>
import { AZ_Flag, EN_Flag } from "../../services/helper";
// import DropDown from "../../components/Dropdown.vue";
export default {
  components: {
    // DropDown
  },

  computed: {
    flag() {
      return this.$store.state.lang === "EN" ? this.enflag : this.azflag;
    }
  },
  data() {
    return {
      azflag: AZ_Flag,
      enflag: EN_Flag,
    };
  },
  methods: {
    onLang(lg) {
      this.$store.dispatch("setLang", lg);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>